import { http } from '@/shared/api/api-client';

import type { GlobalDiscount, GlobalDiscountInput } from '../types/global-discount.types';

/**
 * Global discount Admin API. The backend re-checks the country against the staff member's scope,
 * every permission, and the "one sale per country per period" rule.
 */

export async function getGlobalDiscounts(countryId: number, signal?: AbortSignal) {
  return http.get<GlobalDiscount[]>(`/admin/countries/${countryId}/global-discounts`, { signal });
}

/** coupons.manage. 409 GLOBAL_DISCOUNT_OVERLAP on startsAt when another sale covers the period. */
export async function createGlobalDiscount(countryId: number, input: GlobalDiscountInput) {
  return http.post<GlobalDiscount>(`/admin/countries/${countryId}/global-discounts`, input);
}

/** 409 GLOBAL_DISCOUNT_LOCKED when a used sale's percent or cap would change. */
export async function updateGlobalDiscount(id: number, input: GlobalDiscountInput) {
  return http.put<{ changed: number }>(`/admin/global-discounts/${id}`, input);
}

export async function setGlobalDiscountActive(id: number, active: boolean) {
  return http.post<{ changed: number }>(
    `/admin/global-discounts/${id}/${active ? 'activate' : 'deactivate'}`,
  );
}

export async function setGlobalDiscountBanner(id: number, on: boolean) {
  return http.post<{ changed: number }>(
    `/admin/global-discounts/${id}/banner/${on ? 'on' : 'off'}`,
  );
}
